import { eventBus } from "../../eventBus.js";
import Plotly from "plotly.js-dist-min";

export default {
  data() {
    return {
      drawerOpen: false,
      rightDrawerOpen: false,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    rightSubContentStyle() {
      let width = "calc(100vw - 64px)";
      let left = "64px";
      let right = "64px";

      if (this.screenWidth >= 768) {
        if (this.drawerOpen) {
          
          width = "calc(100vw - 280px)";
          left = "280px";
        }
      }

      return {
        width: width,
        left: left,
        right: right,
      };
    },
    rightContentStyle() {
      let width = "calc(100% - 60px)";

      if (this.screenWidth >= 768) {
        if (this.rightDrawerOpen){
        width = "calc(100% - 310px)";
      }
      }

      return {
        width: width,
      };
    },
    // Studio main screen width calculations
    studioSimpleSelectionWidth() {
      // Simple selection screen should be full 100%
      return "100%";
    },
    studioCreateEditWidth() {
      // On larger screens, use a more dynamic width for create/edit area
      if (this.screenWidth >= 1400) {
        // On very large screens, use up to 92% width when filter is open, 96% when closed
        return this.rightDrawerOpen ? "92%" : "96%";
      } else if (this.screenWidth >= 1024) {
        // On medium-large screens, use 86% when filter is open, 94% when closed
        return this.rightDrawerOpen ? "86%" : "94%";
      } else if (this.screenWidth >= 768) {
        // On tablets/small desktops, use 78% when filter is open, 90% when closed
        return this.rightDrawerOpen ? "78%" : "90%";
      }
      // On mobile, always 100%
      return "100%";
    },
    studioChartWrapperStyle() {
      // Combined style for studio chart wrapper
      return {
        width: this.studioCreateEditWidth,
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.drawerOpen = isOpen;
      }
    },
    handleRightDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.rightDrawerOpen = isOpen;
        localStorage.setItem('sidebarState', isOpen ? 'true' : 'false');
        this.$forceUpdate();
        
        // Emit resizeChart event when filter drawer state changes
        this.$nextTick(() => {
          eventBus.emit("resizeChart");
          eventBus.emit("filterDrawerToggled");
          
          // Add a delay and try to resize any Plotly charts directly
          setTimeout(() => {
            // Try to find and resize any Plotly charts in the DOM
            const plotlyDivs = document.querySelectorAll('[id*="chart"], [id*="plot"]');
            plotlyDivs.forEach(div => {
              if (div._fullLayout) {
                try {
                  Plotly.Plots.resize(div);
                } catch (error) {
                  console.warn('Failed to resize Plotly chart:', error);
                }
              }
            });
          }, 150);
        });
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
};